__turbopack_context__.v({
  "container": "qar2qq_container",
  "invalid": "qar2qq_invalid",
  "label": "qar2qq_label",
  "phoneInput": "qar2qq_phoneInput",
  "valid": "qar2qq_valid",
});
